import Minus2 from '@assets/icons/minus2.svg'
import { Icon } from './Icon'

export const Minus2Icon = Icon(Minus2)
